module.exports = __webpack_public_path__ + "static/img/partner-stl.8f8557f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-stl.png
// module id = DL6Q
// module chunks = 34